<template>
  <div>
  <v-dialog v-model="dialog" scrollable max-width="1200px" persistent>
    <v-card v-if="!loading">
      <v-card-title>Activity Logs</v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pt-10 px-10">
        <v-row class="pb-10 px-5">
          <v-progress-linear
            :value="data.percentage"
            height="25"
          >
            <strong>{{ Math.round(data.percentage * 100) / 100 }}%</strong>
          </v-progress-linear>
        </v-row>
        <v-row class="px-5">
          <span v-if="data.user">Last status update by: {{data.user.first_name}} {{data.user.middle_name}} {{data.user.last_name}}</span>
        </v-row>
        <v-row>
          <v-tabs v-model="tab" centered>
            <v-tab v-for="item in items" :key="item.tab">
              {{ item.tab }}
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item v-for="item in items" :key="item.tab">
              <v-card flat>
                <v-card-text>
                  <component v-bind:is="item.content" :data="data"></component>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="blue darken-1" text @click="closeDialog">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-card v-else>
      <div class="text-center" style="margin-top: 250px; margin-bottom: 250px">
          <v-progress-circular
            :size="100"
            :width="7"
            color="indigo"
            indeterminate
          ></v-progress-circular>
          <h2 class="mt-12 grey--text darken-3">Please wait...</h2>
        </div>
    </v-card>
  </v-dialog>
  </div>
</template>
 <!-- <div class="font-weight-bold ml-8 mb-2"></div>
  <v-timeline align-top dense>
    <v-timeline-item
      v-for="message in computedLogs"
      :key="message.id"
      :color="message.color"
      :icon="message.icon"
      small
    >
      <div
        :class="{ 'grey lighten-3': message.notifStatus }"
        class="py-2 px-4 rounded mt-n4"
      >
        <div class="font-weight-normal">
          <strong>{{ message.from }}</strong> @{{ message.time }}
        </div>
        <div v-html="formatMessage(message.message)"></div>
      </div>
    </v-timeline-item>
  </v-timeline> -->
<script>
  String.prototype.allReplace = function(obj) {
    var retStr = this;
    for (var x in obj) {
      retStr = retStr.replace(new RegExp(x, "g"), obj[x]);
    }
    return retStr;
  };

  let messageConfigDecrypt = {
    "&lt;": "<",
    "&gt;": ">",
  };
  import { mapActions } from "vuex";
  import ByDate from "./views/ByDate.vue"
  import BySubroute from "./views/BySubRoute.vue"
  export default {
    name: "RouteLogTrackModal",
    components: {
      ByDate,
      BySubroute,
    },
    props: {
      dialog: Boolean,
      routeId: Number,
      routeType: String,
      logs: Array,
      notifLogCount: Number,
      userAccessing: Number,
      routeUserAssigned: Number,
    },
    data() {
      return {
        loading: false,
        logData: this.logs,
        dialogm1: "",
        data: {
          percentage: 0,
          route_data: [],
          activity_logs_by_date: [],
          activity_logs_by_subroute: [],
          user: []
        },
        tab: null,
        items: [
          { tab: 'By Date', content: 'ByDate' },
          { tab: 'By Subroute', content: 'BySubroute' }
        ]
      };
    },
    computed: {
      computedLogs() {
        return this.logData;
      },
    },
    methods: {
      ...mapActions(["fetchRouteLog", "viewLogStatus", "overviewLogs"]),
      closeDialog() {
        this.$emit("closeDialog", false);
      },
      formatMessage(message) {
        return message.allReplace(messageConfigDecrypt);
      },
    },
    watch: {
      dialog() {
        if (this.dialog) {
          this.loading = true
          this.overviewLogs(this.routeId).then((res) => {
            this.data.percentage = res.percentage
            this.data.route_data = res.route_data
            this.data.activity_logs_by_date = res.activity_logs_by_date
            this.data.activity_logs_by_subroute = res.activity_logs_by_subroute
            this.data.user = res.last_status_update_user
            this.loading = false
          })
          // if (this.userAccessing !== this.routeUserAssigned) return;
          
          // setTimeout(() => {
          //   // set view to view all
          //   const body = {
          //     logs: this.logs.filter((log) => log.notifStatus),
          //     route_id: this.routeId,
          //     type: this.routeType,
          //   };
          //   this.viewLogStatus(body).then(() => {
          //     this.logData = this.logData.map((data) => ({
          //       ...data,
          //       notifStatus: false,
          //     }));
          //     this.$emit("setNewLogCount", 0);
          //   });
          // }, 3000);
        }
      },
    },
  };
</script>

<style scoped></style>
